const MEASUREMENT_ID = process.env.VUE_APP_GA_MEASUREMENT_ID || 'G-T48DB0MP0E';

let initialized = false;
let scriptRequested = false;

function hasMeasurementId() {
  return /^G-[A-Z0-9]+$/i.test(MEASUREMENT_ID);
}

function ensureDataLayer() {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

function loadGtagScript() {
  if (scriptRequested || !hasMeasurementId()) {
    return;
  }
  scriptRequested = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

export function initAnalytics({ grantConsent = false } = {}) {
  if (!hasMeasurementId()) {
    return false;
  }

  ensureDataLayer();
  loadGtagScript();

  if (!initialized) {
    window.gtag('js', new Date());
    window.gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
    });
    window.gtag('config', MEASUREMENT_ID, {
      send_page_view: false,
      anonymize_ip: true,
    });
    initialized = true;
  }

  if (grantConsent) {
    window.gtag('consent', 'update', {
      analytics_storage: 'granted',
    });
  }

  return true;
}

export function grantAnalyticsConsent() {
  if (!initAnalytics({ grantConsent: true })) {
    return;
  }
  trackPageView(window.location.pathname + window.location.search);
}

export function trackPageView(path) {
  if (!initialized || !hasMeasurementId() || !window.gtag) {
    return;
  }
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function isAnalyticsConfigured() {
  return hasMeasurementId();
}
